import { Button, Card, Icon, IconButton, Stack, Text, tokens } from '@/design';

interface ShellWelcomeCardProps {
  onShowMeAround(opener: HTMLElement | null): void;
  onDismiss(): void;
}

export function ShellWelcomeCard({ onShowMeAround, onDismiss }: ShellWelcomeCardProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="First-session welcome"
      style={{
        position: 'absolute',
        inset: 0,
        display: 'grid',
        placeItems: 'center',
        pointerEvents: 'none',
        zIndex: tokens.zIndex.panel,
      }}
    >
      <div style={{ width: tokens.width.popoverMd, pointerEvents: 'auto' }}>
        <Card
          level={2}
          header="Welcome to GeoViewer"
          actions={
            <>
              <Button
                variant="primary"
                onClick={(event) => onShowMeAround(event.currentTarget)}
              >
                <Icon name="help" size={20} decorative />
                <span>Show me around</span>
              </Button>
              <Button variant="ghost" onClick={onDismiss}>
                Dismiss
              </Button>
            </>
          }
        >
          <Stack direction="column" gap={2}>
            <Stack direction="row" align="center" gap={1}>
              <Icon name="auto_awesome" size={20} decorative />
              <Text variant="body" as="p" style={{ margin: 0 }}>
                Ask the map a question, or open the layer panel on the left to add data.
              </Text>
              <span style={{ flex: '1 1 auto' }} />
              <IconButton aria-label="Dismiss welcome card" onClick={onDismiss}>
                <Icon name="close" size={20} decorative />
              </IconButton>
            </Stack>
          </Stack>
        </Card>
      </div>
    </div>
  );
}
